import Login from '../components/Login';
import ForgotPassword from '../components/Login/components/methods/Password/PasswordReset/ForgotPassword';
import ResetPassword from '../components/Login/components/methods/Password/PasswordReset/ResetPassword';
export const publicRoutes = [
    {
        path: '/login',
        component: Login,
        exact: true,
        skipAuthCheck: false,
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
        exact: true,
        skipAuthCheck: true,
    },
    {
        path: '/reset-password',
        component: ResetPassword,
        exact: true,
        skipAuthCheck: true,
    },
];
export const shouldSkipAuthCheck = (pathname) => {
    var _a;
    const route = publicRoutes.find((r) => r.path === pathname);
    return (_a = route === null || route === void 0 ? void 0 : route.skipAuthCheck) !== null && _a !== void 0 ? _a : false;
};
